import GuestLoginModeForm from "@/components/GuestLoginModeForm";
import LoginMethodsForm from "@/components/LoginMethodsForm";
import { AuthEnums } from "@/enums/Enums";
import { useMeetActions, useMeetDetail } from "@/store/selectors/MeetSelectors";
import { useAuth } from "@nexus/shared-core";
import { Col, Layout, Row, Select, Typography } from "antd";
import clsx from "clsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../shared/i18n";

const { Text } = Typography;
const { Content } = Layout;

const LoginLayout = () => {
  const { t } = useTranslation();
  const auth = useAuth();

  const meetDetail = useMeetDetail();
  const { setMeetDetail } = useMeetActions();

  useEffect(() => {
    (async () => {
      try {
        if (auth?.userData) {
          const { profile, ...userInfo } = auth.userData;
          if (
            auth?.userData?.access_token &&
            auth?.userData?.access_token.length > 0
          ) {
            setMeetDetail({
              mode: "token",
              token: auth?.userData?.access_token,
            });
          }
        }
      } catch (e) {
        auth.signIn();
      }
    })();
  }, [auth, auth?.userData, setMeetDetail]);

  useEffect(() => {
    if (i18n.language === "en-US") {
      document.getElementById("login-bg-img").style.transform = "scaleX(1)";
    } else
      document.getElementById("login-bg-img").style.transform = "scaleX(-1)";
  }, [i18n.language]);

  // const getRandomNumberForDay = () => {
  //   const dayOfWeek = new Date().getDay();
  //   return (dayOfWeek % 6) + 1;
  // };

  return (
    <Content>
      <Row
        className={clsx("login-container", {
          "dir-rtl": i18n.language === "fa-IR",
          "dir-ltr": i18n.language === "en-US",
        })}
      >
        <Col lg={12} md={24} sm={24} xs={24} className="form-container">
          <Select
            className="select-lang"
            options={[
              { value: "en-US", label: t("general.english") },
              { value: "fa-IR", label: t("general.persian") },
            ]}
            onChange={(value) => {
              i18n.changeLanguage(value);
            }}
            value={
              i18n.language === "fa-IR"
                ? t("general.persian")
                : t("general.english")
            }
            variant="borderless"
            size="small"
          />
          {meetDetail.mode === AuthEnums.EnterName ? (
            <GuestLoginModeForm />
          ) : (
            <LoginMethodsForm />
          )}
          <div style={{ height: "15vh" }}></div>
          <div className="bottom-links">
            {/* <Text className="all-rights-reserved">
              {t("joinMeeting.allRightReserved")}
            </Text>
            <div className="additional-links">
              <Link to="">{t("joinMeeting.support")}</Link>
              <Divider type="vertical" />
              <Link to="">{t("joinMeeting.contact")}</Link>
            </div> */}
          </div>
        </Col>
        <Col lg={12} md={0} sm={0} xs={0} className="image-container">
          <div id="login-bg-img" className={`login-bg-img`} />

          <div className="banner">
            <Text className="banner-text font-dot-connected">
              {t("general.smartOrganization")} <br />{" "}
              {t("general.unifiedCollaboration")}
            </Text>
          </div>
        </Col>
      </Row>
    </Content>
  );
};

export default LoginLayout;
